import React from "react";
import { Toaster } from "react-hot-toast";
import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import { ConfirmModalProvider } from "./components/ConfirmModal";
import Login from "./Pages/Login/Login";
import Banner from "./Pages/Dashboard/Banners/Banner";
import Coupons from "./Pages/Dashboard/Coupons/Coupons";
import Vendors from "./Pages/Dashboard/Vendors/Vendors";
import Products from "./Pages/Dashboard/Products/Products";
import Orders from "./Pages/Dashboard/Orders/Orders";
import Transactions from "./Pages/Dashboard/Transactions/Transactions";
import PaymentMethods from "./Pages/Dashboard/PaymentMethods/PaymentMethods";
import Faq from "./Pages/Dashboard/Faqs/Faq";
import Support from "./Pages/Dashboard/Support/Support";
import Settings from "./Pages/Dashboard/Settings/Settings";
import { AuthProvider } from "./context/Context";
import ProtectedRoutes from "./Pages/ProctectRoute";
import Dashbaord from "./Pages/Dashboard/Dashbaord";
import ApplicationForm from "./Pages/Dashboard/Application/Application";
import NotFound from "./Pages/Dashboard/404/404";

import PeopleHub from "./Pages/Dashboard/People/PeopleHub";
import ContactUs from "./Pages/Dashboard/ContactUs/ContactUs";
import Invoice from "./Invoice/Invoice";

import UserDashboard from "./Pages/Dashboard/Driver/View";
import LaundryApp from "./Pages/Dashboard/Orders/Neworder";

const App = () => {
  return (
    <AuthProvider>
      <ConfirmModalProvider>
        <Toaster
          position="top-right"
          gutter={10}
          toastOptions={{ duration: 4000, className: "font-sans" }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/Invoice/:id" element={<Invoice />} />
            <Route path="/" element={<ProtectedRoutes />}>
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="/users" element={<PeopleHub />} />
              <Route path="/users/user/:id" element={<UserDashboard />} />
              <Route path="dashboard" element={<Dashbaord />} />
              <Route path="/neworder" element={<LaundryApp />} />

              <Route path="banners" element={<Banner />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="deliveryprofile" element={<PeopleHub />} />
              <Route path="vendor" element={<Vendors />} />
              <Route path="products" element={<Products />} />

              <Route path="orders" element={<Orders />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="paymentmethods" element={<PaymentMethods />} />
              <Route path="faqs" element={<Faq />} />
              <Route path="contactus" element={<ContactUs />} />
              <Route path="support" element={<Support />} />
              <Route path="settings" element={<Settings />} />
              <Route path="application" element={<ApplicationForm />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ConfirmModalProvider>
    </AuthProvider>
  );
};

export default App;
